module.exports = __webpack_public_path__ + "img/step1.74349010.png";